import gsap from "gsap";
import config from '../config';

export default function playIntro(callback) {
  window.scrollTo(0, 0);

  const tl = gsap.timeline();

  tl.set("#PageContainer", {
    background: "#fff"
  });
  tl.set("#scene-intro-top", {
    visibility: "visible",
  });
  tl.set("#scene-intro-bottom", {
    visibility: "visible",
  });
  tl.set("#device-canvas-container", {
    xPercent: -50,
  });
  tl.addLabel("intro", 2);
  tl.to(
    "#scene-intro",
    5,
    {
      backgroundColor: "rgba(255,255,0,.65)",
    },
    "intro"
  );
  tl.to(
    "#landing-logo",
    5,
    {
      autoAlpha: 0,
    },
    "intro"
  );

  tl.from(
    "#scene-intro-top",
    5,
    {
      yPercent: -100,
      ease: Power3.easeOut,
    },
    "intro"
  );
  tl.from(
    "#scene-intro-bottom",
    5,
    {
      yPercent: 100,
      ease: Power3.easeOut,
    },
    "intro"
  );

  tl.addLabel("intro-device");
  tl.to(
    "#scene-intro",
    4,
    {
      backgroundColor: "rgba(255,255,0,0)",
      ease: Power3.easeIn,
    },
    "intro-device"
  );
  tl.to(
    "#scene-intro-top",
    3,
    {
      yPercent: -100,
      ease: Power0.easeIn,
    },
    "intro-device"
  );
  tl.to(
    "#scene-intro-bottom",
    3,
    {
      yPercent: 100,
      ease: Power0.easeIn,
    },
    "intro-device"
  );
  tl.fromTo(
    "#device-canvas-container",
    3.5,
    {
      yPercent: 150,
      filter: "blur(35px)",
      autoAlpha: 0.5,
    },
    {
      yPercent: function(){
        if (config.mobileLayout){
          return -10;
        }
        return 0;
      },
      filter: "blur(0px)",
      autoAlpha: 1,
      onStart: () => {
        console.log('INTRO SHOW DEVICE VIDEO');
        gsap.set("#device-screen-video-wrapper", { autoAlpha: 1 });
      }
    },
    "intro-device"
  );
  tl.addLabel("intro-header");
  tl.fromTo(
    ".scene-intro-header-first",
    1,
    {
      yPercent: 100,
      xPercent: -50,
      autoAlpha: 0,
    },
    {
      yPercent: 0,
      xPercent: -50,
      autoAlpha: 1,
      onComplete: () => {
        console.log('')
      }
    },
    "intro-header"
  );
  if (callback){
    tl.call(callback);
  }
  // tl.duration(0); // Uncomment to skip past the intro animations
}